// extracted by mini-css-extract-plugin
export default {"emptyContainer":"EmptyContent_emptyContainer__knqy6","emptyDescription":"EmptyContent_emptyDescription__jD799"};